import { useSelector } from 'react-redux';
import constants from '../../constants';
import './index.css';

const ScreenBackgroundWrapper = ({ children }: any) => {
  let { themeType = '' } = useSelector((state: any) => state.setting);
  return (
    <div
      className="screen_background_wrapper"
      style={{
        backgroundImage: `url(${
          themeType === 'dark' ? constants.Images.backgroundImgDark : constants.Images.backgroundImg
        })`,
        overflowY: 'hidden'
      }}>
      {children}
    </div>
  );
};

export default ScreenBackgroundWrapper;
